<template>
    <div class="container">
        <section class="section">
            <div class="container">
                <h1 class="title">Society for Neuroscience 2025</h1>
                <h2 class="subtitle">
                    Posters and Presentations First Authored by staff at the
                    Johns Hopkins Applied Physics Laboratory
                </h2>

                <div
                    v-for="session in sessions"
                    :key="session.title"
                    class="box"
                >
                    <h2 class="title is-5 has-text-link">
                        {{ session.title }}
                    </h2>
                    <div
                        v-for="item in session.items"
                        :key="item.identifier"
                        class="columns session-item"
                    >
                        <div class="column is-2 is-bold pr-4">
                            <strong>{{ item.identifier }}</strong>
                        </div>

                        <div class="column">
                            {{ item.title }}
                            <span
                                v-for="tag in item.tags"
                                :key="tag.class"
                                class="tag is-rounded mx-3"
                                :class="tag.class"
                                >{{ tag.text }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "AplSfn2025",
    data() {
        return {
            sessions: [
                {
                    title:
                        "Saturday, 11/15 - Wednesday, 11/19 - Booth: Johns Hopkins APL, BossDB, and EMBER",
                    items: [
                        {
                            identifier: "Booth #3830",
                            title:
                                "BossDB (Brain Observatory Storage Service and Database) and EMBER (Ecosystem for Multimodal Brain-behavior Experimentation and Research) are cloud-based data archives supported by the NIH BRAIN Initiative for public storage of large-scale neuroscience data. BossDB and EMBER are overseen by the Johns Hopkins Applied Physics Laboratory (APL), the nation's largest university affiliated research center, in collaboration with our partners (Dartmouth, UPenn, Duke, MIT, DANDI, NWB, BIDS).",
                            tags: []
                        }
                    ]
                },
                {
                    title:
                        "Saturday, 11/15, 2:15 pm - Nanosymposium: Insights from the MICrONS Project",
                    items: [
                        {
                            identifier: "NANO 003.06",
                            title:
                                "Method for fiducial-less automated functional co-registration validated on IARPA MICrONS data",
                            tags: [
                                { class: "tag-brain", text: "BRAIN Initiative" }
                            ]
                        }
                    ]
                },
                {
                    title:
                        "Sunday, 11/16, 1 - 5 pm - Multimodal Brain Computer Interfaces",
                    items: [
                        {
                            identifier: "LBP 035.04 [LBP113]",
                            title:
                                "Strong decoding of spoken keywords from audio recordings of a dysarthric individual in a multimodal neural deidentifierr",
                            tags: []
                        }
                    ]
                },
                {
                    title:
                        "Tuesday, 11/18, 8 am - 12 pm - Microanatomy & Neural Dynamics",
                    items: [
                        {
                            identifier: "PSTR 261.24 [C14]",
                            title:
                                "Leveraging Connectomics to Map the Trophospongium, a Putative Morphological Marker for the Spike Initiation Zone, across Drosophila Neurons",
                            tags: [
                                { class: "tag-brain", text: "BRAIN Initiative" }
                            ]
                        }
                    ]
                },
                {
                    title: "Wednesday, 11/19, 8 am - 12 pm - Connectomics",
                    items: [
                        {
                            identifier: "PSTR 418.03 [UU5]",
                            title:
                                "Pencils Down, Everyone: addressing the question of when to stop proofreading an electron microscopy image volume",
                            tags: [
                                { class: "tag-brain", text: "BRAIN Initiative" }
                            ]
                        },
                        {
                            identifier: "PSTR 418.19 [UU21]",
                            title:
                                "NEURD 2.0: End-to-end machine-learning based automated proofreading and feature extraction",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                { class: "tag-connects", text: "CONNECTS" }
                            ]
                        }
                    ]
                },
                {
                    title:
                        "Wednesday, 11/19, 1 - 5 pm - EEG-based Brain Computer Interfaces",
                    items: [
                        {
                            identifier: "PSTR 455.07 [W10]",
                            title:
                                "Evaluating EEG-Based BCI for Screen Interaction in Mobility- and Voice-Constrained Settings",
                            tags: []
                        }
                    ]
                },
                {
                    title:
                        "Wednesday, 11/19, 1 - 5 pm - Data Archives, Tools, Standards, and Analyses",
                    items: [
                        {
                            identifier: "PSTR 477.11 [VV7]",
                            title:
                                "BossDB: Advancing Neuroscience with a Robust Ecosystem for Storing, Accessing, and Analyzing High-Resolution Images, Annotations, and Connectivity Data",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                {
                                    class: "tag-informatics",
                                    text: "Informatics"
                                }
                            ]
                        },
                        {
                            identifier: "PSTR 477.12 [VV8]",
                            title:
                                "NeuVue: A Scalable & Customizable Framework for Electron Microscopy Proofreading",
                            tags: [
                                { class: "tag-brain", text: "BRAIN Initiative" }
                            ]
                        },
                        {
                            identifier: "PSTR 477.13 [VV9]",
                            title:
                                "Benchmarking SmartEM High-Throughput Imaging Strategies Through Repeated Imaging of a Human Cortex Tissue Sample",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                { class: "tag-connects", text: "CONNECTS" }
                            ]
                        },
                        {
                            identifier: "PSTR 477.14 [VV10]",
                            title:
                                "Scalable Metrics for Connectome Quality Assessment",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                { class: "tag-connects", text: "CONNECTS" }
                            ]
                        },
                        {
                            identifier: "PSTR 477.18 [VV14]",
                            title:
                                "EMBER: Towards a living resource for neurophysiological and behavioral data storage, harmonization, dissemination, and analysis",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                { class: "tag-bbqs", text: "BBQS" },
                                {
                                    class: "tag-informatics",
                                    text: "Informatics"
                                }
                            ]
                        },
                        {
                            identifier: "PSTR 477.20 [VV16]",
                            title:
                                "Integration and development of AI/ML and analytical tools for the Data Ecosystem for the Brain-Behavior Research Community",
                            tags: [
                                {
                                    class: "tag-brain",
                                    text: "BRAIN Initiative"
                                },
                                { class: "tag-bbqs", text: "BBQS" }
                            ]
                        }
                    ]
                }
            ]
        };
    }
};
</script>

<style>
.session-item {
    margin-bottom: 20px;
}

.tag.tag-bbqs {
    background-color: #dae3f3;
    color: #1a3d6d;
    border: 1.5px solid #1a3d6d;
}

.tag.tag-connects {
    background-color: #e2f0d9;
    color: #265c26;
    border: 1.5px solid #265c26;
}

.tag.tag-informatics {
    background-color: #f7dfe1;
    color: #b80f0a;
    border: 1.5px solid #b80f0a;
}

.tag.tag-brain {
    color: #6e6e6e;
    border: 1.5px solid #6e6e6e;
}

.tag.tag-bbqs,
.tag.tag-connects,
.tag.tag-informatics,
.tag.tag-brain {
    margin-right: 5px;
}
</style>
